import React from 'react';
const painPoints = ['¿Te sientes frustrada porque no encuentras opciones reales para generar ingresos extras?', '¿Te gustaría conocer el paso a paso garantizado para elaborar jabones artesanales 100% naturales?', '¿No sabes dónde comprar los materiales en tu ciudad… y terminas perdiendo tiempo y dinero?', '¿Quieres aprender en menos de 7 días y comenzar tu propio negocio rentable desde casa?'];
export function PainPoints() {
  return <section className="w-full bg-[var(--bg-dark)] py-8 md:py-12 px-4" data-id="element-212">
      <div className="max-w-4xl mx-auto" data-id="element-213">
        <p className="text-lg md:text-2xl lg:text-3xl text-[var(--text-gray)] mb-4 md:mb-6 text-center" data-id="element-214">
          Querida futura emprendedora,
        </p>

        <h2 className="text-xl md:text-3xl lg:text-4xl font-bold text-[var(--text-light)] mb-6 md:mb-8 text-center" data-id="element-215">
          Déjame preguntarte algo…
        </h2>

        <div className="space-y-3 md:space-y-4" data-id="element-216">
          {painPoints.map((point, index) => <div key={index} className="bg-[var(--bg-card)] p-3 md:p-4 rounded-lg border-l-4 border-[var(--accent-orange)]" data-id="element-217">
              <p className="text-sm md:text-base lg:text-lg xl:text-xl text-[var(--text-light)] leading-relaxed" data-id="element-218">
                {point}
              </p>
            </div>)}
        </div>

        <div className="mt-6 md:mt-8 text-center" data-id="element-219">
          <p className="text-lg md:text-2xl lg:text-3xl font-bold text-[var(--text-light)] mb-2 md:mb-3" data-id="element-220">
            Si asentiste aunque sea a una de estas preguntas…
          </p>
          <p className="text-base md:text-xl lg:text-2xl text-[var(--accent-orange-light)]" data-id="element-221">
            No estás sola.
          </p>
          <p className="text-base md:text-xl lg:text-2xl text-[var(--text-gray)] mt-2" data-id="element-222">
            Y no es tu culpa.
          </p>
        </div>
      </div>
    </section>;
}